module.exports = __webpack_public_path__ + "static/img/dreamweaver.bd44a953.png";